module.exports = __webpack_public_path__ + "static/icons/icon-caret-down--grey-560f53b7be85eaa8e61da0ba7c16a9d3.svg";